<template>
  <div>
    <uhero
      :image="heroData.image"
      :title="heroData.title"
      :body="heroData.body"
      :mobile="heroData.mobile"
      color="white"
    >
      <template v-slot:btn>
        <div
          style="background-color: #FFDD00; padding: 10px; font-size: 20px; letter-spacing: -0.6px; font-family: Montserrat, sans-serif; color:black;"
          v-if="!access"
        >
          Now you pay only <strong>Tk 250</strong> monthly to access
          <strong>130+</strong> hours of video lessons.
          <span
            v-if="canPromo.promo"
            style="padding-left: 5px; padding-top: 20px;"
            >You are eligible for a Tk. 500 discount.
            <strong>Use code: {{ canPromo.code }}</strong></span
          >
        </div>
        <div
          style="background-color: #FFDD00; padding: 10px; font-size: 20px; letter-spacing: -0.6px; font-family: Montserrat, sans-serif; color:black;"
          v-else
        >
          You are enjoying <strong>Premium</strong> access to
          <strong>Upskill Video Library</strong>
        </div>
        <u-btn-outlined @click.native.prevent="startMyFreeTrial" v-if="!access"
          >Start My Yearly Access</u-btn-outlined
        >
        <u-btn-outlined @click.native.prevent="" color="#28a745" v-else
          >You have access to all library videos</u-btn-outlined
        >
        <br />
      </template>
      <div class="container">
        <div class="course-hero-mobile">
          <div class="workshop_hero_content_mobile">
            <h3 class="workshop__text_mobile">
              {{ heroData.title }}
            </h3>
            <div
              style="background-color: #FFDD00; padding: 10px; font-size: 20px; letter-spacing: -0.6px; font-family: Montserrat, sans-serif; color:black;"
              v-if="!access"
            >
              Now you pay only <strong>Tk 250</strong> monthly to access
              <strong>130+</strong> hours of video lessons.
              <span
                v-if="canPromo.promo"
                style="padding-left: 5px; padding-top: 20px;"
                >You are eligible for a Tk. 500 discount.
                <strong>Use code: {{ canPromo.code }}</strong></span
              >
            </div>
            <div
              style="background-color: #FFDD00; padding: 10px; font-size: 20px; letter-spacing: -0.6px; font-family: Montserrat, sans-serif; color:black;"
              v-else
            >
              Now you pay only <strong>Tk 250</strong> monthly to access
            </div>
            <u-btn-outlined
              @click.native.prevent="startMyFreeTrial"
              v-if="!access"
              >Start My Yearly Access</u-btn-outlined
            >
            <u-btn-outlined @click.native.prevent="" color="brown" v-else
              >You are enjoying Video Library Premium</u-btn-outlined
            >
          </div>
        </div>
      </div>
    </uhero>
    <u-nav-wrap>
      <unav :items="navItems" v-model="navItem" @input="filter"></unav>
      <usearch
        v-model="search"
        @input="searchCourse"
        placeholder="Search by Name or Category"
      ></usearch>
    </u-nav-wrap>
    <div class="container">
      <div
        style="font-size: 25px; font-family: Montserrat, sans-serif; margin-left: 2px; margin-bottom: 25px;"
      >
        <!--        Most popular-->
        Video Courses
      </div>
    </div>
    <u-card-list>
      <u-course-card
        :image="c.image"
        :title="c.name"
        :lessons="c.category"
        duration="Unknown"
        v-for="c in showCourses"
        :key="c.id"
        @click="GotoBlogByID(c.id)"
      ></u-course-card>
    </u-card-list>

    <div class="container">
      <div
        style="font-size: 25px; font-family: Montserrat, sans-serif; margin-left: 2px; margin-bottom: 25px;"
      >
        Recently Added
      </div>
    </div>
    <u-card-list>
      <u-course-card
        :image="c.image"
        :title="c.name"
        :lessons="c.category"
        duration="Unkownn"
        v-for="c in courses.slice(0, 5)"
        :key="c.id"
        @click="GotoBlogByID(c.id)"
      ></u-course-card>
    </u-card-list>

    <section class="section">
      <div class="container">
        <div class="nrb_process_section">
          <div class="container-1350">
            <div class="nrb_steps">
              <div class="nrb_step" style="border: none">
                <img
                  src="../assets/endless.png"
                  alt
                  style="filter: brightness(0) invert(1); max-height: 74px"
                />
                <h4 class="nrb_phase">Unlimited Access</h4>
                <p>
                  Choose what you'd like to learn from our extensive
                  subscription library.
                </p>
              </div>
              <div class="nrb_step" style="border: none">
                <img
                  src="../assets/expert.png"
                  alt
                  style="filter: brightness(0) invert(1); max-height: 74px"
                />
                <h4 class="nrb_phase">Expert Teachers</h4>
                <p>
                  Learn from industry experts who are passionate about teaching.
                </p>
              </div>

              <div class="nrb_step" style="border: none">
                <img
                  src="../assets/tablet.png"
                  alt
                  style="filter: brightness(0) invert(1); max-height: 74px"
                />
                <h4 class="nrb_phase">Learn Anywhere</h4>
                <p>
                  Switch between your computer, tablet or mobile device.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="container">
      <div
        style="font-size: 25px; font-family: Montserrat, sans-serif; margin-left: 2px; margin-bottom: 25px;"
      >
        Most Popular
      </div>
    </div>
    <u-card-list>
      <u-course-card
        :image="c.image"
        :title="c.name"
        :lessons="c.category"
        duration="Unkownn"
        v-for="c in courses.slice(6, 11)"
        :key="c.id"
        @click="GotoBlogByID(c.id)"
      ></u-course-card>
    </u-card-list>

    <div class="container infoBox" style="margin-bottom: 100px;">
      <div class="infoBoxContainer">
        <div class="infoBoxHeader1" v-if="!access">
          Get Unlimited Access to
        </div>
        <div class="infoBoxHeader1" v-else>
          You have Unlimited Access to
        </div>
        <div class="infoBoxHeader2">
          Over 130+ Premium Videos
        </div>
        <div class="infoBoxHeaderP" style="color: yellow; margin-bottom: 1.5em">
          New videos are added every month so you can always learn new skills
        </div>
        <div class="infoBoxHeaderP bottomSpace" style="padding-bottom: 5px;">
          Now you pay only Tk 250 monthly to access 130+ hours of video lessons.
        </div>
        <ubtn
          style="margin-bottom: 90px; margin-left: 0"
          v-if="!access"
          @click.native.prevent="startMyFreeTrial"
          >Start My Yearly Access</ubtn
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      payModal: true,
      search: "",
      canPromo: {},
      heroData: {
        mobile: "course-hero-mobile",
        image: require("../assets/banner_library.jpg"),
        title: "Learn from our recorded videos",
        body:
          "We now offer real value for really low price with recorded video of our live sessions.",
      },
      navItem: "",
      navItems: [],
      courses: [],
      showCourses: [],
      searched: "", //unnecessary,
      access: false,
    };
  },
  methods: {
    popular() {
      return this.showCourses.slice(0, 5);
    },
    startMyFreeTrial() {
      this.$router.push({ name: "invoice" });
    },
    searchCourse(value) {
      // console.log(value)
      let result = [];
      result = this.courses.filter(
        (ws) => ws.name.includes(value) || ws.description.includes(value)
      );
      this.showCourses = result;
    },
    filter(category) {
      // console.log(category)
      if (category === "All") {
        this.showCourses = this.courses;
      } else {
        let result = [];
        this.courses.forEach((course) => {
          let categories = course.category.split(",");
          if (categories.includes(category)) {
            result.push(course);
          }
        });
        this.showCourses = result;
      }
    },
  },
  created() {
    this.$upskill.canPromo().then((res) => {
      this.canPromo = res.data;
    });
    // this.courses = this.$courses.getAllCourses();
    // this.navItems = this.$courses.getCategories();
    let pending = window.localStorage.getItem("pendingTransaction");
    if (pending) {
      this.$upskill
        .validatePurchase(pending)
        .then((res) => {
          if (res.data.status == "ACCEPTED") {
            this.$router.push({ name: "thanks" });
            this.access = true;
          } else {
            this.ErrorAlert(
              "Payment declined. Could not complete the purchase!"
            );
          }
        })
        .catch(() => {
          this.ErrorAlert("Payment failed. Could not complete the purchase!");
        });
      window.localStorage.removeItem("pendingTransaction");
    }
    this.$mix.getCourses().then((res) => {
      // console.log(res);
      this.courses = res.courses;
      this.showCourses = [...this.courses];
      this.navItems = res.categories;
      this.access = res.access;
      this.Loaded();
    });
  },
};
</script>

<style>
.floating-img {
  /*width: 464px;*/
  top: -150px;
  height: 465px;
  position: absolute;
}

.ulogo {
  max-width: 224px;
  padding-left: 92px;
  margin-right: 92px;
}
.ulogo-container {
  margin: 0 auto;
}
.centered {
  text-align: center;
  font: Bold 32px/40px Montserrat;
  max-width: 524px;
  margin: auto;
  padding-bottom: 80px;
  padding-top: 40px;
}
.scentered {
  max-width: 900px;
  margin: auto;
}
.optionbox {
  background: #728391 0% 0% no-repeat padding-box;
  opacity: 1;
  padding-left: 195px;
  padding-top: 95px;
  padding-bottom: 95px;
}
.optionstyle {
  font: Bold 24px/29px Open Sans;
  letter-spacing: 0px;
  color: #ffffff;
}
.optionpara {
  font: Regular 18px/29px Open Sans;
  letter-spacing: 0px;
  color: #ffffff;
}

.sectionheader {
  text-align: center;
  font: Bold 32px/40px Montserrat;
  letter-spacing: -0.8px;
  color: #000000;
  text-transform: capitalize;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
}
.subh {
  font: Bold 24px/29px Open Sans;
  letter-spacing: 0px;
  color: #000000;
}
.subp {
  font: Regular 18px/29px Open Sans;
  letter-spacing: 0px;
  color: #000000;
  padding-bottom: 57px;
}
.subc {
  max-width: 890px;
  margin-left: auto;
  margin-right: auto;
}
.steph {
  font: Bold 24px/40px Montserrat;
  letter-spacing: 4.8px;
  color: #ffffff;
  text-transform: uppercase;
}
.stepp {
  font: 24px/32px Open Sans;
  font-weight: 200;
  color: white;
  letter-spacing: 0px;
}
.gap100 {
  margin-top: 100px;
  margin-bottom: 100px;
}
.infoBox {
  max-width: 900px;
  border-radius: 20px;
  background: transparent linear-gradient(257deg, #00ffa8 0%, #6700b5 100%) 0%
    0% no-repeat padding-box;
}
.infoBoxContainer {
  /* max-width: 515px; */
  margin: 0 6em 0;
}
.infoBoxHeader1 {
  text-align: left;
  font: 20px/60px Montserrat;
  letter-spacing: 1.2px;
  color: #ffffff;
  text-transform: uppercase;
  padding-top: 80px;
}
.infoBoxHeader2 {
  text-align: left;
  font-family: "Monrserrat", sans-serif;
  font-size: 48px;
  letter-spacing: -1.2px;
  font-weight: 600;
  color: #ffffff;
  font-weight: 400;
  margin-bottom: 6px;
}
.infoBoxHeaderP {
  font-family: "Open Sans", sans-serif;
  text-align: left;
  font-size: 20px;
  letter-spacing: -0.6px;
  line-height: 40px;
  color: #ffffff;
  font-weight: 400;
}

@media screen and (max-width: 600px) {
  .infoBoxContainer {
    padding: 20px;
    margin: auto;
  }
  .infoBox {
    margin: 0;
    border-radius: 0;
  }
  .floating-img {
    /*width: 464px;*/
    height: 465px;
    position: unset;
  }
  .optionbox {
    padding: 20px 10px;
  }

  .bottomSpace {
    margin-bottom: 1.5em;
  }
  .infoBoxHeader1 {
    font-size: 18px;
  }
  .infoBoxHeader2 {
    padding-top: 0px;
    padding-bottom: 15px;
  }
  .infoBoxHeaderP {
    letter-spacing: -0.4px;
  }
}
</style>
